/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { ToastContainer } from 'react-toastify';
import { ACCOUNTS, SUPER_ADMIN } from '../../../../../../../utils/departments/helpers';
import { useUser } from '../../../../../../../hooks/shared/user/useUser';
import ApprovedTable from './ApprovedTable';
import useCheckTwoDepartments from '../../../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import AccountsNavBar from '../../../../../../layouts/accounts/AccountsNavBar';

const AccountsApprovedRequisitions = ({ history }) => {
  useCheckTwoDepartments(`${ACCOUNTS}`, `${SUPER_ADMIN}`, history);
  const { profile } = useUser();
  const { firstName } = profile;
  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <AccountsNavBar currentPage="All Approved Requisition" position={firstName} />
        <div className="container pt-5">
          <ApprovedTable />
        </div>
      </main>
      <ToastContainer />
    </div>
  );
};

AccountsApprovedRequisitions.propTypes = {
  history: PropTypes.shape(),
};

export default AccountsApprovedRequisitions;
